export class TransSource {

    Key;
    tableName;
    column;

    constructor(Key, tableName, column) {
        this.Key = Key;
        this.tableName = tableName;
        this.column = column;
    }
}
